<template>
    <div class="bg-[#2B2C32] rounded-xl">
        <div class="flex flex-row gap-2 mt-1 p-2">
            <div class="w-[50%]">
                <label class="text-xs mb-1">Search</label>
                <input v-model="search" placeholder="Enter Order #, Product Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            </div>
        </div>
        <new-table-lite 
                class="block w-full min-h-[480px] admin-table"
                :is-loading="table.loading"
                :is-slot-mode="true"
                :columns="table.columns"
                :rows="table.rows"
                :rowClasses="row => row.id ? 'cursor-pointer id-' + row.id : null"
                :total="table.totalRecords"
                :sortable="table.sortable"
                :page="table.page"
                :page-size="table.pagesize"
                :is-static-mode="true"
                @row-clicked="setActive"
                @do-search="doSearch"
                :messages="{
                    pagingInfo: 'Total: {2}',
                    pageSizeChangeLabel: 'Items per Page',
                    gotoPageLabel: 'Go to page',
                    noDataAvailable: 'No records found!',
                }"
             >
                <template v-slot:status="data">
                    <span class="capitalize">{{data.value.status}}</span>
                </template>
                <template v-slot:createdAt="data">
                    <span>{{canadaTime(data.value.platform==='web' ? data.value.submittedAt : data.value.createdAt)}}</span>
                </template>
                <template v-slot:total="data">
                    <span v-if="data.value.total">${{ displayPriceFormat(data.value.total) }}</span>
                    <span v-else>0</span>
                </template>
            </new-table-lite>
            <sales-detail v-if="detailPop" :closeClick="closeDetailModal" :item="detail" />
    </div>
</template>
<script>
import { ref, reactive, defineComponent } from 'vue'
import NewTableLite from '@/components/table/tableLite.vue'
import OrderApis from '@/controllers/OrderShiftApis'
import salesDetail from './Detail.vue'
import moment from 'moment-timezone'
import {mapGetters} from 'vuex'
import StringHelpers from '@/helpers/string'
import { debounce } from 'lodash'

export default defineComponent({
    name: "SaleHistory",
    components: {
        NewTableLite,
        salesDetail
    },
    props: {
        clearComponent: {
            type: Function,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const detailPop = ref(false)
        const detail = ref({})
        const table = reactive({
            loading: false,
            columns: [
                {label: 'Order ID', field:'id', sortable:false},
                {label: 'Date & time', field:'createdAt', sortable: true, isKey: false},
                {label: 'Location', field:'locationName', sortable:false},
                {label: 'Order Status', field: 'status', sortable: false},
                {label: '# of items', field: 'itemCount', sortable: false},
                {label: 'Total Invoiced', field:'total', sortable: false},
            ],
            rows: [],
            totalRecords: 0,
            page: 1,
            pagesize: 10,
            sortable: {
                order: "",
                sort: "",
            },
        })
        const search = ref('')
        return {detailPop, detail, table, search}
    },
    mounted(){
        this.getData()
    },
    computed:{
        ...mapGetters({
            vg_selectedLocation: 'location/selected',
        })
    },
    watch: {
        'item.id'() {
            this.getData()
        },
        search: {
            handler: debounce(function() {
                // tableLite only syncs :page when the value changes. Parent
                // page stays 1 while the table's internal page can be 2+, so
                // assigning 1 is a no-op. 0 forces its watcher (val <= 1 → page 1).
                this.table.page = 0
                this.$nextTick(() => {
                    this.table.page = 1
                    this.getData()
                })
            }, 1000)
        }
    },
    methods: {
        canadaTime(data){
            if(!data) return
            let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
            return moment(data).tz(defaultTimeZone).format('YYYY-MM-DD h:mm a');
        },
        displayPriceFormat(price) {
            return StringHelpers.roundOff(price, 2)
        },
        async getData(sort, order){
            this.table.loading = true
            let params = `page=${this.table.page}&perPage=${this.table.pagesize}`
            if(this.search) {
                params += `&search=${this.search}`
            }
            if(sort) {
                params += `&order=${sort}`
            }
            if(order) {
                params += `&sort=${order}`
            }
            let res = await OrderApis.customerSaleHistory(this.item.id, params)
            if(res.status==200){
                this.table.rows = res.data.payload
            }else{
                this.table.rows = []
            }
            this.table.totalRecords = this.table.rows.length
            this.table.loading = false
        },
        doSearch(offset, limit, order, sort) {
            this.table.pagesize = limit;
            let page = parseInt(offset/limit)+1
            this.table.page = page
            this.getData(order, sort);
        },
        setActive(row) {
            if (row.id) {
                const activeRow = document.getElementsByClassName('id-' + row.id)
                if (activeRow[0] && activeRow[0].parentNode && activeRow[0].parentNode.children) {
                for (const sibling of activeRow[0].parentNode.children) {
                    sibling.classList.remove('active-row')
                }
                }
                activeRow[0].classList.add('active-row')

                this.detail = row
                this.openDetailModal()
            }
        },
        openDetailModal() {
            this.detailPop = true
        },
        closeDetailModal() {
            this.detailPop = false
        },
    }
})
</script>